// La liste des événements (js/react/ecrans/Evenements.jsx).
import { vueReact } from "../react/pont.jsx";
import Evenements from "../react/ecrans/Evenements.jsx";

export const rendre = vueReact(Evenements);
